
import HeaderLogo from './HeaderLogo.vue'
import MenuArea from './MenuArea.vue'
export default { components: { HeaderLogo, MenuArea } }
